import type { FilterModule } from "../index";
import type { Lookups } from "../../types";
import { defaultModelScoreSlice, type ModelScoreSlice } from "./slice";
import { toCompanyFilters, fromCompanyFilters } from "./mapper";
import { getChips, getCount } from "./chips";
import { ModelScoreFilter } from "./ModelScoreFilter";

export const modelScoreModule: FilterModule<ModelScoreSlice, Lookups> = {
  key: "modelScore",
  defaultSlice: defaultModelScoreSlice,
  Component: ModelScoreFilter,
  toCompanyFilters,
  fromCompanyFilters,
  getChips,
  getCount,
};

export { defaultModelScoreSlice, hasCriteria } from "./slice";
export type { ModelScoreSlice, ModelScoreEntry } from "./slice";
export { modelIdFromChipId, MODEL_SCORE_CHIP_ID_PREFIX } from "./chips";
